import { Stack, Typography } from '@mui/material'

interface Props {
  icon: React.ReactNode
  message: string
  testId?: string
}

export const StatusDisplay = ({ icon, message }: Props) => (
  <Stack direction="column" alignItems="center" spacing={0.5} sx={{ mb: 2 }}>
    {icon}
    <Typography variant="heading" fontSize={16}>
      {message}
    </Typography>
  </Stack>
)
